<template>
  <div
    v-if="user"
    :class="{
      'bg-gray-200': disabled && !selected,
      'bg-gray-200 pl-5': selected,
    }"
    class="group grid grid-cols-auto-1-auto col-gap-2 p-3 items-center hover:bg-gray-200"
  >
    <div class="w-12 h-12">
      <avatar :avatar="user.avatar" />
    </div>
    <div class="w-full overflow-hidden" v-if="!loading">
      <div v-if="user.username" class="font-medium leading-tight tracking-wide">{{ user.username }}</div>
      <div
        class="text-sm tracking-wide cursor-pointer"
        @click="copyToClipboard(password)"
        v-if="password"
      >
        Passwort:
        <span class="mr-2">{{ password }}</span>
        <icon class="-mt-px" name="Copy" />
      </div>
    </div>
    <loading v-else />
    <div v-if="checkbox">
      <icon name="Checkbox" :settings="{ active: selected }" />
    </div>
    <div v-else>
      <div class="ml-2 opacity-50 group-hover:opacity-100 transition-opacity duration-150">
        <wd-button transparent @input="destroyUser">
          <icon name="Trash" size="1.3em" />
        </wd-button>
        <wd-button class="ml-4" transparent @input="generatePassword">
          <icon name="PasswordReset" size="1.3em" />
        </wd-button>
        <wd-button
          class="ml-4"
          transparent
          @input="editRoles"
          v-if="permissionCheck('users-update')"
        >
          <icon name="Role" size="1.3em" />
        </wd-button>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";

const Avatar = require("@/modules/avatars/components/Avatar.vue").default;

export default {
  name: "User",
  mixins: [FormMixin],
  data() {
    return {
      lastMessages: null,
      selected: false,
      loading: true,
      password: null
    };
  },
  props: {
    user: {
      default: null,
      type: Object
    },
    checkbox: {
      default: false,
      type: Boolean
    },
    checked: {
      default: false,
      type: Boolean
    },
    remove: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Avatar
  },
  methods: {
    copyToClipboard(text) {
      window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
    },
    openProfile() {
      this.goTo("/profile/" + this.user.id);
    },
    editRoles() {
      this.goTo("/user-roles/" + this.user.id);
    },
    generatePassword() {
      let passwordFormOptions = {
        async: true,
        custom: true,
        type: "user",
        call: "generatePassword",
        id: this.user.id,
        action: response => {
          this.popup({
            title: this.$t("users.user_password_generated"),
            text: this.$t("users.user_password_generated_message", {
              user: this.user.username
            })
          });
          this.password = response.message;
        }
      };
      this.$store.dispatch("dialog/add", {
        title: this.$t("users.generate_password"),
        text: this.$t("users.generate_password_message", {
          user: this.user.username
        }),
        submitFn: () => {
          this.submit(passwordFormOptions);
        }
      });
    },
    destroyUser() {
      let destroyFormOptions = {
        async: true,
        type: "user",
        call: "destroy",
        id: this.user.id,
        action: response => {
          this.popup({
            title: this.$t("users.user_deleted"),
            text: this.$t("users.user_deleted_message", {
              user: this.user.username
            })
          });
        }
      };
      this.$store.dispatch("dialog/add", {
        title: "Löschen bestätigen",
        text: this.$t("users.destroy_user_question", {
          user: this.user.username
        }),
        submitFn: () => {
          this.submit(destroyFormOptions);
        }
      });
    }
  },
  computed: {},
  created() {
    this.ownUser = this.$store.getters["auth/current"];
    if (this.checked) {
      this.selected = this.checked;
      this.emitInput(true);
    }
  },
  async mounted() {
    this.loaded();
  }
};
</script>
